var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmarkLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12962_10865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7592 1.29861C13.1473 0.921298 13.7776 0.921298 14.1657 1.29861C14.5537 1.67591 14.5537 2.28866 14.1657 2.66597L8.90628 7.77623L14.1625 12.8895C14.5506 13.2668 14.5506 13.8796 14.1625 14.2569C13.7745 14.6342 13.1442 14.6342 12.7561 14.2569L7.49984 9.1436L2.24047 14.2539C1.85238 14.6312 1.22212 14.6312 0.834035 14.2539C0.445947 13.8766 0.445947 13.2638 0.834035 12.8865L6.09341 7.77623L0.83714 2.66295C0.449051 2.28564 0.449051 1.67591 0.83714 1.29861C1.22523 0.921298 1.85548 0.921298 2.24357 1.29861L7.49984 6.40887L12.7592 1.29861Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12962_10865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9091,
    height: 15.4545,
    fill: "white",
    transform: "translate(0.546875 0.046875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkLarge);
export default __webpack_public_path__ + "static/media/xmark-large.ab23f5f6c6308eb7d75f6f0dc063f30b.svg";
export { ForwardRef as ReactComponent };